import React from 'react';

import styled from '@emotion/styled';
import { LevelUpProfilePageContextProvider } from 'screens/Profile/competencySection/context/provider';
import { AgendaSidePanelContextProvider } from 'screens/oneOnOne/levelUp/agendaSidePanel/context/provider';
import LevelUpDrawer from 'screens/oneOnOne/levelUp/competencySidePanel';
import { LevelUpSidePanelContextProvider } from 'screens/oneOnOne/levelUp/competencySidePanel/context/provider';

import { ProfileHeaderCard } from './components/ProfileHeaderCard';
import ProfileSummaryContainer from './components/ProfileSummaryContainer';

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors.surface.EBEFF3};

  /* min-width: 800px;
  max-width: 924px; */
  margin: 0 auto;
  /* @media (min-width: 1025px) {
    max-width: 80%;
  } */
  margin-top: 12px;
  margin-bottom: 12px;
`;

const ProfilePage = ({ employee }) => (
  <LevelUpSidePanelContextProvider>
    <AgendaSidePanelContextProvider>
      <LevelUpProfilePageContextProvider employeeId={employee?.id}>
        <ProfileContainer>
          <ProfileHeaderCard employee={employee} />
          <ProfileSummaryContainer employeeId={employee?.id} />
          <LevelUpDrawer source="Profile Page" />
        </ProfileContainer>
      </LevelUpProfilePageContextProvider>
    </AgendaSidePanelContextProvider>
  </LevelUpSidePanelContextProvider>
);

export { ProfilePage };
